module.exports = __webpack_public_path__ + "Roboto-RegularItalic.f3660f493ea5e5206484.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.eot
// module id = 101
// module chunks = 2